/**
 * 解析 SHEIN publishOrEdit 失败信息，映射到站内表单字段，便于标红与定位。
 */

function collectValidationRows(res) {
  const info = res?.info && typeof res.info === 'object' ? res.info : res;
  if (!info || typeof info !== 'object') return [];
  const buckets = [
    info.pre_valid_result,
    info.mcc_valid_result,
    info.preValidResult,
    info.mccValidResult,
  ];
  const out = [];
  buckets.forEach((arr) => {
    if (!Array.isArray(arr)) return;
    arr.forEach((row) => {
      if (!row || typeof row !== 'object') return;
      out.push(row);
    });
  });
  return out;
}

function firstMessage(row) {
  if (Array.isArray(row?.messages)) {
    const hit = row.messages.map((m) => String(m || '').trim()).find(Boolean);
    if (hit) return hit;
  }
  return String(row?.message || row?.msg || '').trim();
}

function mapPlatformFieldToForm(fieldRaw = '', message = '') {
  const field = String(fieldRaw || '').trim().toLowerCase();
  const msg = String(message || '').toLowerCase();
  const blob = `${field} ${msg}`;

  if (/title|product_name|multi_language_name|name_list/.test(blob)) {
    return { field: 'title', section: 'basic' };
  }
  if (/supplier_code(?!_)|商家货号|货号/.test(blob) && !/supplier_sku|卖家sku|商家\s*sku/.test(blob)) {
    return { field: 'supplierCode', section: 'basic' };
  }
  if (/supplier_sku|卖家sku|商家\s*sku|sku重复|sku 重复/.test(blob)) {
    return { field: 'supplierSku', section: 'spec' };
  }
  if (/category|类目/.test(blob)) {
    return { field: 'categoryId', section: 'basic' };
  }
  if (/brand/.test(blob)) {
    return { field: 'brandCode', section: 'basic' };
  }
  if (/product_attribute|类目属性|attribute/.test(blob) && !/sale_attribute|size_attribute/.test(blob)) {
    return { field: 'productAttributes', section: 'attrs' };
  }
  if (/size_attribute|尺码/.test(blob)) {
    return { field: 'sizeChart', section: 'size' };
  }
  if (/skc|主规格|sale_attribute|image|图片|主图/.test(blob)) {
    return { field: 'skcList', section: 'spec' };
  }
  if (/quantity_info|package_type|件数|包装类型|包装尺寸|weight|重量/.test(blob)) {
    return { field: 'supply', section: 'size' };
  }
  if (/cost|currency|币种|供货价|price|stock|库存|仓库|warehouse/.test(blob)) {
    return { field: 'supply', section: 'spec' };
  }
  if (/site|站点|shelf|上架/.test(blob)) {
    return { field: 'selectedSites', section: 'sales' };
  }
  if (/description|desc|描述/.test(blob)) {
    return { field: 'description', section: 'basic' };
  }
  return { field: 'form', section: 'basic' };
}

/**
 * @returns {{ field: string, section: string, message: string }[]}
 */
export function extractSheinPublishFieldErrors(res, fallbackMessage = '') {
  const rows = collectValidationRows(res);
  const errors = [];
  const seen = new Set();

  rows.forEach((row) => {
    const message = firstMessage(row);
    if (!message) return;
    const platformField = String(row?.field || row?.field_name || row?.fieldName || '').trim();
    const mapped = mapPlatformFieldToForm(platformField, message);
    const key = `${mapped.field}::${message}`;
    if (seen.has(key)) return;
    seen.add(key);
    errors.push({
      field: mapped.field,
      section: mapped.section,
      message,
    });
  });

  if (!errors.length) {
    const detail = [res?.msg, res?.message, res?.info?.msg, res?.info?.message, fallbackMessage]
      .map((v) => (v == null ? '' : String(v).trim()))
      .find((v) => v && v.toUpperCase() !== 'OK');
    if (detail) {
      const mapped = mapPlatformFieldToForm('', detail);
      errors.push({
        field: mapped.field,
        section: mapped.section,
        message: detail,
      });
    }
  }
  return errors;
}

/** @returns {Record<string, string>} */
export function fieldErrorsToMap(errors = []) {
  const map = {};
  (Array.isArray(errors) ? errors : []).forEach((item) => {
    if (!item?.field || !item?.message) return;
    if (!map[item.field]) map[item.field] = item.message;
  });
  return map;
}
